/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

/**
 * Switcher component
 */
@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
})
export class SwitcherComponent implements OnInit {
  // set variable
  public isVisible!: boolean;

  constructor(private offcanvasService: NgbOffcanvas) {}

  ngOnInit(): void {
    // assign value
    this.isVisible = false;
  }

  /**
   * Set dark theme
   */
  public setDark(value: string): void {
    document
      .getElementById('theme-opt')
      ?.setAttribute('href', './assets/css/style-dark.min.css');
  }

  /**
   * Set light theme
   */
  public setLight(value: string): void {
    (document.querySelector('.t-rtl-dark') as HTMLElement).style.display =
      'none';
    (document.querySelector('.t-rtl-light') as HTMLElement).style.display =
      'inline-block';
    document
      .querySelector('.theme-opt')
      ?.setAttribute('href', './assets/css/bootstrap-rtl.min.css');
  }

  /**
   * Set dark-rtl theme
   */
  public darkRtl(value: string): void {
    document.documentElement.dir = 'rtl';
    (document.querySelector('.t-rtl-dark') as HTMLElement).style.display =
      'none';
    (document.querySelector('.t-ltr-dark') as HTMLElement).style.display =
      'inline-block';
    document
      .querySelector('.theme-opt')
      ?.setAttribute('href', './assets/css/bootstrap-dark-rtl.min.css');
    document
      .querySelector('.theme-opt-style')
      ?.setAttribute('href', './assets/css/style-dark-rtl.min.css');
  }
  /**
   * Set dark-light theme
   */
  public darkLtr(value: string): void {
    (document.querySelector('.t-dark') as HTMLElement).style.display = 'none';
    (document.querySelector('.t-light') as HTMLElement).style.display =
      'inline-block';
    (document.querySelector('.t-rtl-dark') as HTMLElement).style.display =
      'inline-block';
    (document.querySelector('.t-rtl-light') as HTMLElement).style.display =
      'none';
    (document.querySelector('.t-ltr-dark') as HTMLElement).style.display =
      'none';
    document
      .querySelector('.theme-opt')
      ?.setAttribute('href', './assets/css/bootstrap-dark.min.css');
    document
      .querySelector('.theme-opt-style')
      ?.setAttribute('href', './assets/css/style-dark.min.css');
    document.documentElement.dir = 'ltr';
  }

  /**
   * Set dark-light theme
   */
  public lightLtr(value: string): void {
    (document.querySelector('.t-dark') as HTMLElement).style.display =
      'inline-block';
    (document.querySelector('.t-light') as HTMLElement).style.display = 'none';
    (document.querySelector('.t-rtl-dark') as HTMLElement).style.display =
      'none';
    (document.querySelector('.t-rtl-light') as HTMLElement).style.display =
      'inline-block';
    (document.querySelector('.t-ltr-dark') as HTMLElement).style.display =
      'none';
    document
      .querySelector('.theme-opt')
      ?.setAttribute('href', './assets/css/bootstrap.min.css');
    document
      .querySelector('.theme-opt-style')
      ?.setAttribute('href', './assets/css/style.min.css');
    document.documentElement.dir = 'ltr';
  }
  /**
   * Set rtl theme
   */
  public setRtl(value: string): void {
    document.documentElement.dir = 'rtl';
    (document.querySelector('.t-rtl-light') as HTMLElement).style.display =
      'none';
    (document.querySelector('.t-ltr-light') as HTMLElement).style.display =
      'inline-block';
    document
      .querySelector('.theme-opt')
      ?.setAttribute('href', './assets/css/bootstrap-rtl.min.css');
    document
      .querySelector('.theme-opt-style')
      ?.setAttribute('href', './assets/css/style-rtl.min.css');
  }
  /**
   * Set light theme
   */
  public setLtr(value: string): void {
    document.documentElement.dir = 'ltr';
    (document.querySelector('.t-ltr-light') as HTMLElement).style.display =
      'none';
    (document.querySelector('.t-rtl-light') as HTMLElement).style.display =
      'inline-block';
    document
      .querySelector('.theme-opt')
      ?.setAttribute('href', './assets/css/bootstrap.min.css');
    document
      .querySelector('.theme-opt-style')
      ?.setAttribute('href', './assets/css/style.min.css');
  }

  /**
   * Toggle switcher
   */
  public onChangeSwitch(): void {
    this.isVisible = !this.isVisible;
  }

  // Demo Offcanvas
  public openLeft(content: TemplateRef<any>): void {
    this.offcanvasService.open(content, { position: 'start' });
  }
}
